import { render, staticRenderFns } from "./SaveFormModal.vue?vue&type=template&id=1f23db66&scoped=true&"
import script from "./SaveFormModal.vue?vue&type=script&lang=js&"
export * from "./SaveFormModal.vue?vue&type=script&lang=js&"
import style0 from "./SaveFormModal.vue?vue&type=style&index=0&id=1f23db66&prod&scoped=true&lang=scss&"
import style1 from "./SaveFormModal.vue?vue&type=style&index=1&id=1f23db66&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f23db66",
  null
  
)

export default component.exports